import DNSRecord from './DNSRecord'
export default DNSRecord
